import React from 'react'

function GoogleFormEmbed({ googleFormSrc, height = 1260 }) {
  return (
    <div className="p-2 lg:p-8 flex justify-center align-center">
      <iframe
        src={googleFormSrc}
        width="640" height={height} frameBorder="0" marginHeight="0" marginWidth="0">Loading…
      </iframe>
    </div>
  )
}

export default GoogleFormEmbed
